export const DASHBOARD_CARDS = [
  {
    id: "cadastros_resumo",
    title: "Pessoas e produtos",
    description: "Resumo rápido dos cadastros principais.",
    group: "Cadastros",
    component: "Totalizador",
    permissions: ["pessoas", "produtos"],
    permissionMode: "any",
    defaultLayout: { x: 0, y: 0, w: 4, h: 2 },
  },
  {
    id: "contas_hoje",
    title: "Contas de hoje",
    description: "Valores a receber e a pagar no dia.",
    group: "Financeiro",
    component: "TotalizadorContas",
    permissions: ["financeiro", "contasReceber", "contasPagar"],
    permissionMode: "any",
    defaultLayout: { x: 4, y: 0, w: 8, h: 2 },
  },
  {
    id: "ticket_medio",
    title: "Ticket médio",
    description: "Valor médio por venda no período.",
    group: "Vendas",
    component: "TicketMedio",
    permissions: ["vendas", "pedidos", "nfe"],
    permissionMode: "any",
    defaultLayout: { x: 0, y: 2, w: 4, h: 3 },
  },
  {
    id: "margem_lucro",
    title: "Margem de lucro",
    description: "Percentual de margem e lucro estimado.",
    group: "Vendas",
    component: "MargemLucro",
    permissions: ["vendas", "nfe"],
    permissionMode: "any",
    defaultLayout: { x: 4, y: 2, w: 4, h: 3 },
  },
  {
    id: "vendas_periodo",
    title: "Vendas",
    description: "Total vendido no período selecionado.",
    group: "Vendas",
    component: "Vendas",
    permissions: ["vendas", "pedidos", "nfe"],
    permissionMode: "any",
    defaultLayout: { x: 8, y: 2, w: 4, h: 3 },
  },
  {
    id: "meta_faturamento",
    title: "Meta de faturamento",
    description: "Progresso da meta mensal de faturamento.",
    group: "Financeiro",
    component: "MetaFaturamento",
    permissions: ["metas", "financeiro", "vendas"],
    permissionMode: "any",
    defaultLayout: { x: 0, y: 5, w: 4, h: 4 },
  },
  {
    id: "inadimplencia",
    title: "Inadimplência",
    description: "Acompanhamento de valores vencidos.",
    group: "Financeiro",
    component: "Inadimplencia",
    permissions: ["financeiro", "contasReceber"],
    permissionMode: "any",
    defaultLayout: { x: 0, y: 9, w: 4, h: 3 },
  },
  {
    id: "relacao_financeira",
    title: "Relação financeira",
    description: "Receitas, despesas e total no período.",
    group: "Financeiro",
    component: "RelacaoFinanceira",
    permissions: ["financeiro", "contasReceber", "contasPagar"],
    permissionMode: "any",
    defaultLayout: { x: 4, y: 5, w: 4, h: 5 },
  },
  {
    id: "relacao_vendas",
    title: "Relação de vendas",
    description: "Comparativo de vendas por período.",
    group: "Vendas",
    component: "GraficoVendas",
    permissions: ["vendas", "pedidos", "nfe"],
    permissionMode: "any",
    defaultLayout: { x: 8, y: 5, w: 4, h: 5 },
  },
  {
    id: "aniversariantes",
    title: "Aniversariantes",
    description: "Clientes e pessoas aniversariantes do dia.",
    group: "Cadastros",
    component: "Aniversariantes",
    permissions: ["pessoas", "clientes"],
    permissionMode: "any",
    defaultLayout: { x: 0, y: 12, w: 4, h: 4 },
  },
  {
    id: "produtos_mais_vendidos",
    title: "Produtos mais vendidos",
    description: "Ranking dos produtos com maior volume.",
    group: "Produtos",
    component: "TopProdutosVendidos",
    permissions: ["produtos", "vendas", "nfe"],
    permissionMode: "any",
    defaultLayout: { x: 4, y: 10, w: 4, h: 4 },
  },
  {
    id: "maiores_clientes",
    title: "Maiores clientes",
    description: "Clientes com maior volume de compras.",
    group: "Clientes",
    component: "TopClientes",
    permissions: ["pessoas", "clientes", "vendas"],
    permissionMode: "any",
    defaultLayout: { x: 8, y: 10, w: 4, h: 4 },
  },
  {
    id: "caixa_aberto",
    title: "Caixa aberto agora",
    description: "Caixas em operação e saldo operacional atual.",
    group: "Operação",
    component: "CaixaAberto",
    permissions: ["caixa", "financeiro"],
    permissionMode: "any",
    showInUserConfig: false,
    defaultLayout: { x: 0, y: 14, w: 4, h: 3 },
  },
  {
    id: "estoque_critico",
    title: "Estoque crítico",
    description: "Produtos ativos abaixo do estoque mínimo.",
    group: "Produtos",
    component: "EstoqueCritico",
    permissions: ["produtos", "estoque"],
    permissionMode: "any",
    showInUserConfig: false,
    defaultLayout: { x: 4, y: 14, w: 4, h: 4 },
  },
  {
    id: "comissao_vendedor",
    title: "Minha meta e comissão",
    description:
      "Meta do mês, faixa atual, comissão acumulada e próximos ganhos.",
    group: "Comissões",
    component: "ComissaoVendedor",
    permissions: [],
    requiresSeller: true,
    defaultLayout: { x: 0, y: 18, w: 8, h: 8 },
    responsiveLayout: {
      tablet: { w: 6, h: 10 },
      mobile: { w: 1, h: 14 },
    },
  },
];

const normalizeKey = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9/-]+/g, "");

export const dashboardCardIds = () => DASHBOARD_CARDS.map((card) => card.id);

export const getResourceKeys = (recursos = []) => {
  const keys = new Set();

  (recursos || []).forEach((menu) => {
    if (menu?.checked) {
      keys.add(normalizeKey(menu.name));
    }

    const submenus = Array.isArray(menu?.submenus) ? menu.submenus : [];

    submenus.forEach((submenu) => {
      if (!submenu?.checked || submenu?.disabled) return;

      keys.add(normalizeKey(submenu.url));
      keys.add(normalizeKey(submenu.name));
    });
  });

  return keys;
};

export const isDashboardCardEligible = (
  card,
  recursos = [],
  currentUser = {}
) => {
  if (card.requiresSeller && !currentUser?.id_vendedor) return false;
  if (currentUser?.admin) return true;

  const permissions = card.permissions || [];
  if (!permissions.length) return true;

  const resourceKeys = getResourceKeys(recursos);
  const hasPermission = (permission) =>
    resourceKeys.has(normalizeKey(permission));

  return card.permissionMode === "all"
    ? permissions.every(hasPermission)
    : permissions.some(hasPermission);
};

export const getEligibleDashboardCards = (recursos = [], currentUser = {}) =>
  DASHBOARD_CARDS.filter((card) =>
    isDashboardCardEligible(card, recursos, currentUser)
  );

export const getConfigurableDashboardCards = (
  recursos = [],
  currentUser = {}
) =>
  getEligibleDashboardCards(recursos, currentUser).filter(
    (card) => card.showInUserConfig !== false
  );

export const sanitizeDashboardCardIds = (
  cardIds = [],
  eligibleCards = DASHBOARD_CARDS
) => {
  const eligibleIds = new Set(eligibleCards.map((card) => card.id));
  const sanitized = [];

  (cardIds || []).forEach((cardId) => {
    if (!eligibleIds.has(cardId) || sanitized.includes(cardId)) return;
    sanitized.push(cardId);
  });

  return sanitized;
};

export const getDefaultDashboardLayout = (cards = DASHBOARD_CARDS) =>
  cards.map((card) => ({
    i: card.id,
    ...card.defaultLayout,
  }));

export const normalizeDashboardLayout = (
  layout = [],
  cards = DASHBOARD_CARDS
) => {
  const cardsById = cards.reduce((acc, card) => {
    acc[card.id] = card;
    return acc;
  }, {});
  const used = new Set();
  const normalized = [];

  (layout || []).forEach((item) => {
    const card = cardsById[item?.i];
    if (!card || used.has(card.id)) return;

    used.add(card.id);
    normalized.push({
      i: card.id,
      x: Math.max(0, Number(item.x) || 0),
      y: Math.max(0, Number(item.y) || 0),
      w: Math.min(12, Math.max(1, Number(item.w) || card.defaultLayout.w)),
      h: Math.max(1, Number(item.h) || card.defaultLayout.h),
    });
  });

  cards.forEach((card) => {
    if (used.has(card.id)) return;

    normalized.push({
      i: card.id,
      ...card.defaultLayout,
    });
  });

  return normalized;
};
